import { defaultPost } from '@/utils/request'

export const login = defaultPost('/User/Login')
export const sendCode = defaultPost('/User/SendCode')
export const nav = defaultPost('/User/Nav')
export const changePwd = defaultPost('/User/ChangePwd')

export const list = defaultPost('/UserManager/List')
export const addoredit = defaultPost('/UserManager/AddOrEdit')
export const del = defaultPost('/UserManager/Del')
export const resetpwd = defaultPost('/UserManager/ResetPwd')
export const loginRecords = defaultPost('/UserManager/login_records')